import { useEffect, useState } from "react";
import { Table, Modal, Button, Card, Row, Col } from "react-bootstrap";
import API from "../api";

const Proyectos = () => {
  const [proyectos, setProyectos] = useState([]);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);

  // ✅ Función auxiliar para convertir fecha MongoDB a texto legible
  const formatearFecha = (fechaObj) => {
    if (!fechaObj) return "";
    if (typeof fechaObj === "string") return fechaObj;
    if (fechaObj.$date) return new Date(fechaObj.$date).toLocaleDateString("es-CL");
    return "";
  };

  useEffect(() => {
    fetch(`${API}/proyectos`)
      .then((res) => res.json())
      .then((data) => {
        const proyectosFormateados = data.map((p) => ({
          ...p,
          fechaFormateada: formatearFecha(p.fechaInicio),
        }));
        setProyectos(proyectosFormateados);
      })
      .catch((err) => console.error("Error al obtener proyectos:", err));
  }, []);

  return (
    <div className="container py-4">
      <h2 className="fw-bold fs-4 text-center mb-4">Gestión de Proyectos</h2>

      <Table striped bordered hover responsive className="shadow-sm text-center align-middle">
        <thead className="table-dark">
          <tr>
            <th>Nombre Proyecto</th>
            <th>Responsable</th>
            <th>Fecha Inicio</th>
            <th>Trabajadores</th>
            <th>Presupuesto</th>
            <th>Gastos Totales</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          {proyectos.map((p, i) => (
            <tr key={i} style={{ cursor: "pointer" }} onClick={() => setProyectoSeleccionado(p)}>
              <td>{p.nombre}</td>
              <td>{p.responsable}</td>
              <td>{p.fechaFormateada}</td>
              <td>{p.trabajadores}</td>
              <td>${p.presupuesto?.toLocaleString("es-CL")}</td>
              <td>${p.gastosTotales?.toLocaleString("es-CL")}</td>
              <td>
                <span className={`badge ${p.estado?.toLowerCase().includes("terminado") ? "bg-success" : "bg-warning text-dark"}`}>
                  {p.estado}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal de Detalle */}
      <Modal show={!!proyectoSeleccionado} onHide={() => setProyectoSeleccionado(null)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Resumen del Proyecto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {proyectoSeleccionado && (
            <Card className="p-3">
              <Row className="mb-3">
                <Col><strong>Nombre:</strong> {proyectoSeleccionado.nombre}</Col>
                <Col><strong>Responsable:</strong> {proyectoSeleccionado.responsable}</Col>
              </Row>
              <Row className="mb-3">
                <Col><strong>Fecha de Inicio:</strong> {formatearFecha(proyectoSeleccionado.fechaInicio)}</Col>
                <Col><strong>Estado:</strong> {proyectoSeleccionado.estado}</Col>
              </Row>
              <Row className="mb-3">
                <Col><strong>Presupuesto:</strong> ${proyectoSeleccionado.presupuesto?.toLocaleString("es-CL")}</Col>
                <Col><strong>Gastos Totales:</strong> ${proyectoSeleccionado.gastosTotales?.toLocaleString("es-CL")}</Col>
              </Row>
              <Row className="mb-3">
                <Col><strong>Trabajadores Involucrados:</strong> {proyectoSeleccionado.trabajadores}</Col>
              </Row>
              <hr />
              <h6 className="mt-3">Gestiones disponibles (próximamente):</h6>
              <ul className="mb-0">
                <li>Documentación del Proyecto</li>
                <li>Cronograma</li>
                <li>Asignación de tareas y usuarios</li>
              </ul>
            </Card>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setProyectoSeleccionado(null)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Proyectos;
